import * as React from 'react'

import { useLocation } from 'react-router-dom'
import { useRecoilValue } from 'recoil'

import logo from '../../../misc/images/logos/westminster_crest.svg'
import { translate } from '../../../state/locale/selectors/translate'
import styles from './Error404.module.scss'

export const Error404 = () => {
  const { pathname } = useLocation()
  const i18n = useRecoilValue(translate).errors.error404

  return (
    <div className={styles.errorWrapper}>
      <img className={styles.crestLogo} src={logo} alt={i18n.text} />
      <h2>{i18n.text}</h2>
      <p>{pathname}</p>
      <p>{i18n.question}</p>
    </div>
  )
}
